import React, { useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import './ShopWithAPurpose.scss';
import { BGIMAGE_TYPES } from 'shared/settings/config';
import { Button, Form, Modal, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import { getAdminHeaders, getAdminUrl, getBuyerHeaders, getBuyerUrl, getSellerHeaders, getSellerUrl } from 'shared/http';
import { contentList, contentUpdate, itemdetail, shopWithPurposeBgImageAdd, shopWithPurposeCarouselImageList, shopWithPurposeCarouselImageUpdate } from 'shared/settings/apiconfig';
import heic2any from 'heic2any';
import FileType from "file-type/browser";
import { DokaImageEditor } from 'react-doka';
import { getEditorDefaults } from 'shared/doka';

export const ShopWithAPurpose = (props) => {
    const width = window.innerWidth;
    const textEditorRef = useRef(null);
    const quillModules = useRef({
         toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['link'],
            ['clean']
        ],
        clipboard: {
            matchVisual: false,
            matchers: [
                ['span', (node, delta) => {
                  delta.ops.forEach(op => {
                    if (op.attributes) {
                      const isLink = !!op.attributes.link;          
                      Object.keys(op.attributes).forEach(attr => {
                        if (
                          attr !== 'link' &&
                          !(attr === 'color' && isLink) 
                        ) {
                          delete op.attributes[attr];
                        }
                      });
                    }
                  });
                  return delta;
                }],
                ['a', (node, delta) => {
                  return delta;
                }]
              ]
            },
    });
    const bgTargetImage = {width: 1200, height: 600 };
    const bgImageEditorDefaults = {
        imageCropAspectRatio: 512 / 268,
        cropEnableSelectPreset: false,
        imageCropMinSize: { width: 512, height: 268 },
    };

    const [pageLoading, setPageLoading] = useState(true);
    const [items, setItems] = useState([
        { id: null, value: '', error: '', imgSrc: null, tempImg: null, itemUrl: null },
        { id: null, value: '', error: '', imgSrc: null, tempImg: null, itemUrl: null },
        { id: null, value: '', error: '', imgSrc: null, tempImg: null, itemUrl: null },
        { id: null, value: '', error: '', imgSrc: null, tempImg: null, itemUrl: null },
        { id: null, value: '', error: '', imgSrc: null, tempImg: null, itemUrl: null },
        { id: null, value: '', error: '', imgSrc: null, tempImg: null, itemUrl: null },
        { id: null, value: '', error: '', imgSrc: null, tempImg: null, itemUrl: null },
        { id: null, value: '', error: '', imgSrc: null, tempImg: null, itemUrl: null },
        { id: null, value: '', error: '', imgSrc: null, tempImg: null, itemUrl: null },
        { id: null, value: '', error: '', imgSrc: null, tempImg: null, itemUrl: null },
        { id: null, value: '', error: '', imgSrc: null, tempImg: null, itemUrl: null },
        { id: null, value: '', error: '', imgSrc: null, tempImg: null, itemUrl: null }
    ]);
    const [contentData, setContentData] = useState({
        "id": "",
        "contentname": "homebanner",
        "contenttype": "JSON",
        "screenname": "homebanner",
        "contentapp": "MOBILE",
        "status": "Active",
        "jsoncontent": {
            "header": "",
            "subheader": "",
            "description": "",
            "bgimage": "",
            "button": {
                "link": "/view-more-items/featured",
                "title": "Start Shopping"
            }
        }
    });
    const [message, setMessage] = useState({ show: false, type: '', msg: '' });
    const [showItemUrlModal, setShowItemUrlModal] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState('');
    const [selectedItemUrl, setSelectedItemUrl] = useState('');
    const [previewImageUrl, setPreviewImageUrl] = useState('');
    const [showPreviewImgUrl, setShowPreviewImgUrl] = useState(false);
    const [selectedItemIndex, setSelectedItemIndex] = useState('');
    const [modalMessage, setModalMessage] = useState({ show: false, type: '', msg: '' });
    const [showMediaModal, setShowMediaModal] = useState(false);
    const [tempBgImg, setTempBgImg] = useState(null);
    const [saleBgImageErrorMsg, setSaleBgImageErrorMsg] = useState({ show: false, type: '', msg: '' });
    const [spinnerLoad, setSpinnerLoad] = useState(false);
    const [previewLoad, setPreviewLoad] = useState(false);
    const [modalLoad, setModalLoad] = useState(false);
    const [noDataMsg, setNoDataMsg] = useState(false);
    const [showPreviewwModel,  setPreviewModel] = useState(false);
    const [itemDetails,  setSeItemDetails] = useState('');
    const [mobileView, setMobileView] =  useState(false)
    const [isLoading, setIsLoading] =  useState(false);

    useEffect(() => {
        setPageLoading(true);
        setNoDataMsg(false);
        Promise.all([getContentList(), getCarouselImageList()]).then((responses) => {
            setContentData(prev => ({
                ...prev,
                id: responses[0].id,
                jsoncontent: {
                    ...prev.jsoncontent,
                    ...JSON.parse(responses[0].jsoncontent)
                }
            }));
            setSeItemDetails(responses[1])
            formatAndSetImage(responses[1]);
            setPageLoading(false);
        }).catch(error => {
            setPageLoading(false);
            setNoDataMsg(true);
        });
    }, [])

    const getContentList = () => {
        let data = {
            "filter": [
                { "field": "status", "value": "Active", "op": "=", "join": "AND" },
                { "field": "screenname", "value": "homebanner", "op": "=", "join": "AND" },
                { "field": "contenttype", "value": "JSON", "op": "=", "join": "AND" }
            ]
        }

        return new Promise((resolve, reject) => {
            axios.post(getBuyerUrl(`${contentList}`), data, getBuyerHeaders()).then(response => {
                resolve(response.data.data[0]);
            }).catch((error) => {
                reject(false);
            });
        });
    }

    const getCarouselImageList = () => {
        return new Promise((resolve, reject) => {
            axios.get(getAdminUrl(shopWithPurposeCarouselImageList), getAdminHeaders()).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(false);
            });
        });
    }

    const formatAndSetImage = (imageData) => {
        const updatedItemImageData = [];
        if (Array.isArray(imageData) && imageData.length > 0) {
                for (let i = 0; i < items.length; i++) {
                updatedItemImageData.push({
                    value: '',
                    error: '',
                    tempImg: null,
                    imgSrc: imageData[i]?.itemdisplayurl || '',
                    itemUrl: imageData[i]?.url || '',
                    id: imageData[i]?.id || ''
                });
            }
            const updatedItemDetails = imageData.map((obj) => ({
                ...obj,
                previewImg: obj?.itemdisplayurl || ''
            }));
            setSeItemDetails(updatedItemDetails);

        } else {
            updatedItemImageData = items
        }
        setItems(updatedItemImageData);
    }

    const uploadBgPurposeImage = () => {
        document.getElementById('bgimage').click();
    }

    const changeImage = async (event) => {
        setSaleBgImageErrorMsg({ show: false, type: "", msg: "" });
        let uploadedFile = event.target.files[0];
        if (!uploadedFile) return;

        let mimetype = await FileType.fromBlob(uploadedFile);
        let blob = null;
        let tempImgUrl = URL.createObjectURL(uploadedFile);
        
        let img = new Image();
        img.src = tempImgUrl;

        img.onload = async () => {
            if (img.width < 1200 || img.height < 600) {
                setSaleBgImageErrorMsg({ show: true, type: "error", msg: "Please upload image with minimum size of 1200W x 600H pixels." });
                event.target.value = '';
                return;
            }

            if (mimetype?.mime === "image/heic" && mimetype?.ext === 'heic') {
                blob = await heic2any({
                    blob: uploadedFile,
                    toType: 'image/jpeg',
                    quality: 0.94,
                });
                
                tempImgUrl = URL.createObjectURL(blob);
            }
            setTempBgImg(tempImgUrl);
            setShowMediaModal(true);
            
            event.target.value = '';
        }
    }

    const cancelImage = () => {
        setTempBgImg(null);
        setShowMediaModal(false);        
    }

    const setHomeBgImageData = (output) => {
        let reader = new FileReader();
        let base64 = null;

        reader.readAsDataURL(output.dest);
        reader.onload = () => {
            base64 = reader.result.split(',')[1];

            let payload = {
                url: base64,
                type: output.dest.type === 'application/pdf' ? 'pdf' : 'image'
            }
            setIsLoading(true);
            axios.post(getAdminUrl(shopWithPurposeBgImageAdd), JSON.stringify({ data: payload }), getAdminHeaders()).then(response => {
                if (response.data.status == "success") {
                    setShowMediaModal(false);
                    setContentData(prev => ({
                        ...prev,
                        jsoncontent: {
                            ...prev.jsoncontent,
                            bgimage: response.data.data
                        }
                    }))
                    setIsLoading(false); 
                }
            }).catch(error => {
                setIsLoading(false); 
            })
        };
    }

    const setPurposeData = (type, event) => {
        setContentData(prev => ({
            ...prev,
            jsoncontent: {
                ...prev.jsoncontent,
                [type]: event
            }
        }))
    }

    const uploadImage = (index, id) => {
        setSelectedItemId(id);
        setShowItemUrlModal(true);
        setSelectedItemIndex(index);
    }


    const handleSave = () => {
        setSpinnerLoad(true);
        let data = {
            ...contentData,
            jsoncontent: JSON.stringify(contentData.jsoncontent)
        };
        axios.put(getBuyerUrl(contentUpdate), JSON.stringify({ data: data }), getBuyerHeaders()).then(response => {
            if (response.data.status == "success") {
                setMessage({ show: true, type: "success", msg: "Shop With A Purpose content is saved successfully" });
                setSpinnerLoad(false);
                setTimeout(() => {
                    setMessage({ show: false, type: "", msg: "" });
                }, 3000);
            }
        }).catch(error => {
            setMessage({ show: true, type: "error", msg: "error.response.data.message" });
            setSpinnerLoad(false);
            setTimeout(() => {
                setMessage({ show: false, type: "", msg: "" });
            }, 3000);
        })
    };

    const handleCancel = () => {
        props.history.goBack();
    };

    const handlePreivewFn = () => {
        setPreviewModel(true)
    }
    const closePreviewFn = () => {
        setPreviewModel(false)
        setMobileView(false)
    }


    const inputChange = (event) => {
        setSelectedItemUrl(event.target.value);
    }

    const handleItemSave = () => {
        setModalLoad(true);
        setPreviewImageUrl('');
        setShowPreviewImgUrl(false);
        let data = {
            id: selectedItemId,
            url: selectedItemUrl
        }
        axios.post(getAdminUrl(shopWithPurposeCarouselImageUpdate), JSON.stringify({ data: data }), getAdminHeaders()).then(response => {
            if (response.data.status == "success") {
                setModalMessage({ show: true, type: "success", msg: "Image url is updated successfully" });
                getCarouselImageList().then(response => {
                    setSelectedItemIndex('');
                    setSelectedItemId('');
                    setModalLoad(false);
                    formatAndSetImage(response);
                    setShowItemUrlModal(false);
                    setSelectedItemUrl('');
                    setModalMessage({ show: false, type: "", msg: "" });
                });
            }
        }).catch(error => {
            setModalMessage({ show: true, type: "error", msg: error.response.data.message });
            setModalLoad(false);
            setPreviewImageUrl('');
        })
    }

    
    const ItemCarousels = ({ items, mobileView }) => {
        const safeItems = Array.isArray(items) ? items : [];
        const [currentSet, setCurrentSet] = React.useState(0);
        const [itemsPerSet, setItemsPerSet] = React.useState(4); // default desktop
        const carouselRef = React.useRef(null);

        // Update items per set based on width / mobileView
        React.useEffect(() => {
            const updateItemsPerSet = () => {
                const width = window.innerWidth;
                if (width > 1100 && !mobileView) {
                    setItemsPerSet(4); // desktop
                } else if (width > 600 || mobileView) {
                    setItemsPerSet(2); // tablet
                } else {
                    setItemsPerSet(1); // mobile
                }
            };
            updateItemsPerSet();
            window.addEventListener("resize", updateItemsPerSet);
            return () => window.removeEventListener("resize", updateItemsPerSet);
        }, [mobileView]);

        // Group into chunks based on itemsPerSet
        const chunkItems = (arr, size) => {
            const result = [];
            for (let i = 0; i < arr.length; i += size) {
                result.push(arr.slice(i, i + size));
            }
            return result;
        };
        const sets = chunkItems(safeItems, itemsPerSet);

        // Touch swipe variables
        const startX = React.useRef(0);
        const scrollLeft = React.useRef(0);

        const onTouchStart = (e) => {
            startX.current = e.touches[0].pageX - carouselRef.current.offsetLeft;
            scrollLeft.current = carouselRef.current.scrollLeft;
        };

        const onTouchMove = (e) => {
            if (!startX.current) return;
            const x = e.touches[0].pageX - carouselRef.current.offsetLeft;
            const walk = startX.current - x;
            carouselRef.current.scrollLeft = scrollLeft.current + walk;
        };

        const onScroll = () => {
            const setWidth = carouselRef.current.offsetWidth;
            const scrollPosition = carouselRef.current.scrollLeft;
            const newSet = Math.round(scrollPosition / setWidth);
            setCurrentSet(newSet);
        };

        // Auto-slide every 10 seconds
        React.useEffect(() => {
            if (!sets.length) return;
            const interval = setInterval(() => {
                const nextSet = (currentSet + 1) % sets.length;
                const setWidth = carouselRef.current.offsetWidth;
                carouselRef.current.scrollTo({
                    left: nextSet * setWidth,
                    behavior: "smooth",
                });
                setCurrentSet(nextSet);
            }, 10000);

            return () => clearInterval(interval);
        }, [currentSet, sets.length]);

        return (
            <div
                className={`${mobileView ? 'mobile-shop-with-itemcard-view' : 'shop-with-itemcard-view'}`}

            >
                {/* Carousel container */}
                <div
                    ref={carouselRef}
                    style={{
                        display: "flex",
                        overflowX: "auto",
                        scrollSnapType: "x mandatory",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                    }}
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                    onScroll={onScroll}
                >
                    {sets.map((set, setIndex) => (
                        <div
                            key={setIndex}
                            style={{
                                flex: "0 0 100%",
                                display: "grid",
                                gridTemplateColumns:
                                    itemsPerSet === 1
                                        ? "1fr"
                                        : itemsPerSet === 2
                                            ? "1fr 1fr"
                                            : "1fr 1fr",
                                gap: "16px",
                                padding: "10px",
                                scrollSnapAlign: "start",
                                alignItems: "start",       
                                gridAutoRows: "max-content"
                            }}
                        >
                            {set.map((item, i) => (
                                <div
                                    key={item?.id ?? `${setIndex}-${i}`}
                                    style={{
                                        background: "#fff",
                                        borderRadius: 8,
                                        overflow: "hidden",
                                        boxShadow: "0 4px 8px rgba(0,0,0,0.08)",
                                    }}
                                >
                                    <div style={{ height: "180px", overflow: "hidden" }}>
                                        <img
                                            src={item?.previewImg || ""}
                                            alt={item?.title || ""}
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                padding: "8px",
                                                objectFit: "cover",
                                            }}
                                        />
                                    </div>
                                    <div className="preview-item-title">{item?.title || ""}</div>
                                    <div
                                        style={{
                                            padding: "10px",
                                            textAlign: "center",
                                            background: "#f4f4f4",
                                            fontWeight: 700,
                                        }}
                                    >
                                        Bid Now
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>

                {/* Dots */}
                <div
                    style={{
                        marginTop: "15px",
                        display: "flex",
                        alignItems: 'center',
                        justifyContent: "center",
                        gap: "8px",
                    }}
                >
                    {sets.map((_, idx) => (
                        <div
                            key={idx}
                            onClick={() => {
                                const setWidth = carouselRef.current.offsetWidth;
                                carouselRef.current.scrollTo({
                                    left: idx * setWidth,
                                    behavior: "smooth",
                                });
                                setCurrentSet(idx);
                            }}
                            style={{
                                width: currentSet === idx ? 15 : 12,
                                height: currentSet === idx ? 15 : 12,
                                borderRadius: "50%",
                                background: currentSet === idx ? "#d0df00" : "#d6d6d6",
                                transition: "0.3s",
                                cursor: "pointer",
                            }}
                        />
                    ))}
                </div>

            </div>
        );
    };
      
      

    const handlePreview = () => {
        setPreviewLoad(true);
        const match = selectedItemUrl.match(/\/item\/(\d+)\//);
        const itemId = match ? match[1] : null;
        axios.get(getSellerUrl(`${itemdetail}/${itemId}`), getSellerHeaders()).then(response => {
            if (response.data.status == "success") {
                setPreviewLoad(false);
                setPreviewImageUrl(response.data.data[0].displayimageurl);
                setShowPreviewImgUrl(true);
                setSelectedItemIndex('');
            }
        }).catch(error => {
            setPreviewLoad(false);
            setModalMessage({ show: true, type: "error", msg: error.response.data.message ? error.response.data.message : error.response.message });
            setModalLoad(false);
            setPreviewImageUrl('');
        }
        );
    }

    const closeItemUrlModal = () => {
        setPreviewImageUrl('');
        setMessage({ show: false, type: "", msg: "" });
        setSelectedItemId('');
        setShowPreviewImgUrl(false);
        setShowItemUrlModal(false);
        setModalMessage({ show: false, type: "", msg: "" });
        setSaleBgImageErrorMsg({ show: false, type: "", msg: "" });
        setModalLoad(false);
        setSelectedItemUrl('');
    }

    const RenderImage = ({ image, index }) => (
        <div key={`item-${index}`} className='d-flex flex-column align-items-center justify-content-center mobile-width mt-3' style={{ width: "25%" }}>
            <h6 className='font-weight-bold' style={{ fontSize: "16px" }}>Image {index+1}</h6>
            <div className="d-flex flex-row justify-content-center mb-3 mt-3 image-box clickable" style={{ gap: "10px" }}>
                {
                    image.imgSrc ? (
                        <img src={image.imgSrc} alt="invalid image url" width="100%" height="100%" title={image.itemUrl} onClick={() => { window.open(image.itemUrl) }} />
                    ) : (
                        <div className="clickable text-center w-100" onClick={() => uploadImage(index, image.id)}>
                            <img src={`${process.env.PUBLIC_URL}/static/icons/profile/default_2.svg`} alt="default" height="75" width="75" />
                        </div>
                    )
                }
            </div>

            <div className="d-flex flex-row justify-content-center w-100">
                <span className="text-secondary clickable" onClick={() => uploadImage(index, image.id)}>
                    Click here to change
                </span>
            </div>
        </div>
    );

    return (
        pageLoading ?

            <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
            </div> : 
            noDataMsg ? 

            <div className='d-flex h-100 align-items-center justify-content-center'>
                No Data Found
            </div> : 

            <div className="featured-container p-5 h-100 mobile-px-5">
                <h3 className='font-weight-bold'>Shop With A Purpose</h3>
                <div>
                    <h5 className='font-weight-bold mt-5'>Carousel Background</h5>
                    <div>
                        <div className="w-100 d-flex align-items-center border bg-white p-3 clickable">
                            <Form.Control id="bgimage" type="file" name="BgImage upload" accept={BGIMAGE_TYPES} hidden onChange={(event) => { changeImage(event) }} />
                            {
                                contentData.jsoncontent.bgimage ? (
                                    <img src={contentData.jsoncontent.bgimage} alt="invalid bg image" width="100%" height="642px" onClick={uploadBgPurposeImage} />
                                ) : (
                                    <div className="clickable text-center w-100" onClick={uploadBgPurposeImage}>
                                        <img src={`${process.env.PUBLIC_URL}/static/images/upload.png`} alt="default" height="75" width="75" />
                                    </div>
                                )
                            }
                        </div>
                        { saleBgImageErrorMsg.show ? <div className='d-flex align-items-center justify-content-center font-weight-bold mt-3' style={{ color: saleBgImageErrorMsg.type === "success" ? "green" : saleBgImageErrorMsg.type === "error" ? "red" : "" }}>{saleBgImageErrorMsg.msg}</div> : ''}
                        <div className='d-flex align-items-center justify-content-center mt-3'>
                            <Button onClick={uploadBgPurposeImage}>Upload Image</Button>
                            <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>
                                {'Banner images supported format in .png, jpeg and webp, the minimum size of the image needs to be 1200W X 600H'}</Tooltip>}>
                                <i className={`fa fa-question-circle`} style={{ fontSize: "20px", marginLeft: "5px", marginTop: '1.5px' }}></i>
                            </OverlayTrigger>
                        </div>
                    </div>
                    <div className='w-100 d-flex mt-5' style={{ gap: "10px" }}>
                        <div className='w-50'>
                            <label className='font-weight-bold'>Eyebrow Heading</label>
                            <div className="text-editor">
                                <div className="wrapper">
                                    <ReactQuill theme="snow"
                                       modules={quillModules.current}
                                       placeholder="type your prompt here"
                                        ref={textEditorRef}
                                        value={contentData.jsoncontent.header}
                                        onChange={(e) => setPurposeData("header", e)} />
                                </div>
                            </div>
                        </div>

                        <div className='w-50'>
                            <label className='font-weight-bold'>Heading</label>
                            <div className="text-editor">
                                <div className="wrapper">
                                    <ReactQuill theme="snow"
                                       modules={quillModules.current}
                                       placeholder="type your prompt here"
                                        ref={textEditorRef}
                                        value={contentData.jsoncontent.subheader}
                                        onChange={(e) => setPurposeData("subheader", e)} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <label className='font-weight-bold'>Text</label>
                        <div className="text-editor">
                            <div className="wrapper">
                                <ReactQuill theme="snow"
                                    modules={quillModules.current}
                                    placeholder="type your prompt here"
                                    ref={textEditorRef}
                                    value={contentData.jsoncontent.description}
                                    onChange={(e) => setPurposeData("description", e)} />
                            </div>
                        </div>
                    </div>

                   
                </div>

                <div>
                    <h5 className='font-weight-bold mt-5'>Carousel Images</h5>
                    <h5 className='mt-5 font-weight-bold'>Page 1</h5>
                    <div className='w-100 item-image mt-3'>
                        {
                            Array.from({ length: 4 }, (_, i) => i).map(index => <RenderImage image={items[index]} index={index} /> )
                        }
                    </div>
                    <h5 className='mt-5 font-weight-bold'>Page 2</h5>
                    <div className='w-100 item-image mt-3'>
                        {
                            Array.from({ length: 4 }, (_, i) => i + 4).map(index => <RenderImage image={items[index]} index={index} /> )
                        }
                    </div>
                    <h5 className='mt-5 font-weight-bold'>Page 3</h5>
                    <div className='w-100 item-image mt-3 mb-5'>
                        {
                            Array.from({ length: 4 }, (_, i) => i + 8).map(index => <RenderImage image={items[index]} index={index} /> )
                        }
                    </div>
                        {message.show ? <div className='d-flex align-items-center justify-content-center mt-3' style={{ color: message.type === "success" ? "green" : message.type === "error" ? "red" : "" }}>{message.msg}</div> : ''}

                        <div className="d-flex flex-row align-items-center justify-content-center mt-3">
                            <Button  type="button" className="mx-1" style={{ width: "100px" }} onClick={() => { handleCancel() }}>Cancel</Button>
                            <Button type="button" className="mx-1" style={{ width: "100px" }} onClick={() => { handlePreivewFn() }}>Preview</Button>
                            <Button type="button" variant='secondary' style={{ float: "left", width: "100px" }} className="save-button mx-1" onClick={(e) => { handleSave(e) }}>Save {spinnerLoad ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                        </div>
                </div>

                <Modal show={showMediaModal} size="lg" animation={false} onHide={() => {setShowMediaModal(false)}}>
                    <Modal.Header>
                        <Button type="button" onClick={cancelImage} disabled={isLoading} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body className="doka d-flex flex-column align-items-center justify-content-center">
                            <div className={'doka-profile-layout'} style={{ width: '100%' }}>
                                {isLoading ? <div className='w-100 text-bold text-center' style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                }} >Kindly wait while we upload your images. We appreciate your patience! <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />  </div> :
                            <DokaImageEditor {...getEditorDefaults(bgTargetImage)}   
                            {...bgImageEditorDefaults} src={tempBgImg} onProcess={setHomeBgImageData} />}
                        </div>
                    </Modal.Body>
                </Modal>

                {showItemUrlModal ?
                    <Modal centered show={showItemUrlModal} className="confirmModal justify-content-center" onHide={() => closeItemUrlModal()}>
                        <Modal.Header className='align-items-end justify-content-end clickable'>
                            <div className="close-icon" onClick={() => { closeItemUrlModal() }}></div>
                        </Modal.Header>
                        <Modal.Body className="p-4 text-center">
                            <div className="float-control">
                                <Form.Control type="text" id="itemurl" name="itemurl" value={selectedItemUrl}
                                    className='form-control-active' placeholder=" " onChange={inputChange} autoComplete='off' />
                                <Form.Label htmlFor="buyerspremium" className="required">Item Url</Form.Label>
                            </div>
                            {showPreviewImgUrl ? <div className='w-100 d-flex align-items-center justify-content-center'>
                                <img src={previewImageUrl} alt="invalid image url" width="30%" height="30%" />
                            </div> : ''}
                            {modalMessage.show ? <div className='d-flex align-items-center justify-content-center font-weight-bold' style={{ color: modalMessage.type === "success" ? "green" : modalMessage.type === "error" ? "red" : "" }}>{modalMessage.msg}</div> : ''}
                            <div className='d-flex align-items-center justify-content-center mt-3'>
                                <Button className="btn-white mx-1" onClick={() => { handlePreview() }} disabled={!selectedItemUrl}>Preview {previewLoad ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                                <Button variant='secondary' style={{ float: "left", width: "100px" }} className="save-button mx-1" onClick={() => { handleItemSave() }} disabled={modalMessage.msg}>Save {modalLoad ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                            </div>
                        </Modal.Body>
                    </Modal>
                    : ''}
                    <Modal size="md" className="notes" show={showPreviewwModel} id={mobileView ? `mobile-shop-with-purpose` : `shop-with-purpose` } >
                        <Modal.Header
                            style={{
                                border: "none",
                                display: "flex",
                                padding: "0px",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <div className='ml-4'>
                                {width > 600 && <Button onClick={()=>{setMobileView(!mobileView)}}>{!mobileView ? `Click To Mobile View` : `Click To Web View`}</Button>}

                            </div>

                            <Button
                                type="button"
                                onClick={() => closePreviewFn()}
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </Button>
                        </Modal.Header>


                        <Modal.Body className="shop-purpose-body">
                            {contentData.jsoncontent.bgimage && (
                                <div
                                    className="shop-purpose-bg"
                                    style={{ backgroundImage: `url(${contentData.jsoncontent.bgimage})` }}
                                >
                                    {/* LEFT: text only */}
                                    <div className="shop-purpose-text">
                                        {contentData.jsoncontent.header && (
                                            <div
                                                className={`preview-header  ${mobileView && 'mt-3'}`}
                                                dangerouslySetInnerHTML={{ __html: contentData.jsoncontent.header }}
                                            ></div>
                                        )}
                                        {contentData.jsoncontent.subheader && (
                                            <div
                                                className="subheader"
                                                dangerouslySetInnerHTML={{ __html: contentData.jsoncontent.subheader }}
                                            ></div>
                                        )}
                                        {contentData.jsoncontent.description && (
                                            <div
                                                className={`description ${mobileView && 'mb-3'}`}
                                                dangerouslySetInnerHTML={{ __html: contentData.jsoncontent.description }}
                                            ></div>
                                        )}
                                    </div>

                                    {/* RIGHT: carousel */}
                                    <ItemCarousels items={itemDetails} mobileView={mobileView} />
                                </div>
                            )}
                        </Modal.Body>

                    </Modal>
            </div>
    );
};
